// Feature #288 — All Staff roster (sm-manager). Phase-1 data foundation
// for the deferred resourcing view; the "find people with X ≥ N" filter
// UI is explicitly out of scope.
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { PageHeader } from '@/components/ui/PageHeader'
import { formatDateTime } from '@/utils/dateFormat'
import { getStaffRoster, SmStaffRosterEntry } from '@/api/sm'

const th: React.CSSProperties = {
  textAlign: 'left',
  padding: '10px 12px',
  fontSize: '12px',
  fontWeight: 600,
  color: 'var(--color-dark-grey)',
  borderBottom: '1px solid var(--color-light-grey)',
  textTransform: 'uppercase',
}

const td: React.CSSProperties = {
  padding: '10px 12px',
  fontSize: '14px',
  borderBottom: '1px solid var(--color-light-grey)',
}

const StaffList: React.FC = () => {
  const [staff, setStaff] = useState<SmStaffRosterEntry[]>([])
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    getStaffRoster()
      .then(setStaff)
      .catch((e) => setError(e?.message || 'Failed to load roster'))
  }, [])

  return (
    <div>
      <PageHeader title="All Staff — Skills" />
      <div style={{ padding: '24px' }}>
        {error && <div style={{ color: '#b91c1c' }}>{error}</div>}
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={th}>Name</th>
              <th style={th}>Skills rated</th>
              <th style={th}>Open deltas</th>
              <th style={th}>Stale skills</th>
              <th style={th}>Last assessed</th>
            </tr>
          </thead>
          <tbody>
            {staff.map((s) => (
              <tr key={s.user_id}>
                <td style={td}>
                  <Link
                    to={`/sm/staff/${s.user_id}`}
                    style={{ color: 'var(--color-magenta)', textDecoration: 'none', fontWeight: 500 }}
                  >
                    {s.display_name}
                  </Link>
                  <div style={{ fontSize: '12px', color: 'var(--color-dark-grey)' }}>{s.email}</div>
                </td>
                <td style={td}>{s.skills_rated}</td>
                <td style={td}>
                  {s.open_deltas > 0 ? (
                    <strong style={{ color: 'var(--color-magenta)' }}>{s.open_deltas}</strong>
                  ) : (
                    0
                  )}
                </td>
                <td style={td}>
                  {s.stale_skills > 0 ? (
                    <strong style={{ color: '#92400e' }}>{s.stale_skills}</strong>
                  ) : (
                    0
                  )}
                </td>
                <td style={{ ...td, color: 'var(--color-dark-grey)', fontSize: '13px' }}>
                  {s.last_assessed_at ? formatDateTime(s.last_assessed_at) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default StaffList
